module.exports = __webpack_public_path__ + "mp3/Joy_to_the_World.mp3";